// react
import React, { useContext, useEffect, useState } from 'react';

// third-party
import PropTypes from 'prop-types';
import Container from './Container';
import IconProgressBar from './progressbar/IconProgressBar';
import Pages from './pages';
import ControlButton from './controls/ControlButton';
import { DataContext, DataProvier } from '../context/DataContext';
import useToken from '../hooks/useToken';
import { ImgNext } from '../svg';
import { contentTitles, COVERAGE_IDS, COVERAGE_WITH_MOTO_IDS, PLAN_ID } from '../utils/constanst';
import http from '../services/http';
import { endPoints } from '../utils/constanst';
import { getAgeActuarial, getIMCWithInfo, mapData } from '../utils/helpers';
import { initPage } from '../data/data';

import {
    BrowserRouter,
    Redirect,
    Route,
    Switch,
} from 'react-router-dom';
import Cotizacion from './pages/Cotizacion';
import tarificar, { calculatePrima, getResumen } from '../services/tarificar';
import { sendDocuments, sendNotificationPayByPhone, sendNotificationRate } from '../services/notifications';
import DebitoAutomatico from './forms/DebitoAutomatico';
import Modal from 'react-modal';


import { BlackListCheckValidate, DocumentCheckValidate, AllValidate} from '../services/openbanking';
import { ImgAlert } from '../svg';
import Compressor from 'compressorjs';

const Root = () => {

    const { loading } = useToken();

    useEffect(() => {

        if (!loading) {

            setTimeout(() => {
                const preloader = document.querySelector('.site-preloader');

                if (preloader) {
                    preloader.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'opacity') {
                            preloader.parentNode.removeChild(preloader);
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                }
            }, 600);

        }

    }, [loading]);



    return (
        <DataProvier loading={loading}>
            <Container>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <Switch>
                        <Route exact path="/debitoautomatico" component={DebitoAutomatico} />
                        <Route exact path="/continue" component={props => <Layout loading={loading} {...props} />} />
                        <Route exact path="/" component={props => <Cotizacion loading={loading} {...props} />} />
                        <Redirect to="/" />
                    </Switch>
                </BrowserRouter>
            </Container>
        </DataProvier>
    );
}

const Layout = ({ loading, ...rest }) => {

    const [index, setIndex] = useState(initPage);
    const { poliza, setPoliza } = useContext(DataContext);
    const [openModal, setOpenModal] = useState(false);
    const [loadingValidate, setLoadingValidate] = useState(false);

    const prevState = rest?.location?.state;

    const increment = disabled => {

        if (index !== pages)
            setIndex(index + 1);

    }

    const decrement = () => {
        if (index !== 0)
            setIndex(index - 1);
        else
            back();
    };

    const pagar = async (id) => {

        const { nombreTarjeta, numeroTarjeta, codigoSeguridad, fechaExpiracion, prima, primeraCuota, pagoMoneda, telefonoCelular, email } = poliza;

        const data = {
            policyId: id,
            cardHolder: nombreTarjeta,
            cardNumber: String(numeroTarjeta).replace('-', '').replace('-', '').replace('-', '').replace('-', ''),
            cvv: codigoSeguridad,
            amountApp: parseFloat(primeraCuota),
            currencyApp: pagoMoneda,
            expirationDate: fechaExpiracion,
            celular: telefonoCelular,
            email: email
        }

        setPoliza(prev => ({ ...prev, datosTarjeta: data }));

        http(endPoints.payment).post({ ...data })
            .then(resp => {
                setPoliza(_poliza => ({
                    ..._poliza,
                    showDialogPagoSuccess: true,
                    reference: resp.codigoAutorizacion,
                    codigoAutorizacion: resp.codigoAutorizacion,
                    cnpoliza: resp.policy,
                    transactionId: resp.transactionId,
                    creating: false,
                    showDialogFinish: false
                }));

                if (poliza.frecuenciaPagos !== "1")
                    rest.history.push('/debitoautomatico', { ...data, cvv: null });

            })
            .catch(err => {

                setPoliza(_poliza => ({
                    ..._poliza,
                    faild: true,
                    reference: '',
                    creating: false,
                    showDialogFinish: false,
                }));

            });

    }

    useEffect(() => {
        

    },[])

    const validateQuestions = async i => {

        //validamos openbanking
        if(i === 0)
        {
            
           /* let resultVal = await validateData(); 
            setOpenModal(!resultVal.valid);
            return resultVal.valid;*/
        }

       
        if (i === 5) { //pagar

            if (poliza.captcha == null) {
                setPoliza({
                    ...poliza,
                    showCaptchaValidation: true
                });
                return;
            }

            const _poliza = mapData(poliza);

            setPoliza({
                ...poliza,
                creating: true,
                showDialogFinish: true
            });

            if (poliza.id === 0) {

                http(endPoints.createVida).post(_poliza).then(resp => {

                    sendDocuments({ ...poliza, id: resp.id });

                    setPoliza(poliza => ({ ...poliza, id: resp.id, aseguradoId: resp.asegurado }));

                    if (poliza.tipPago === true)
                        sendNotificationPayByPhone({ ...poliza, id: resp.id });

                    if (poliza.tipPago === false) {

                        pagar(resp.id);

                    } else {
                        setPoliza(poliza => ({ ...poliza, creating: false, }));
                    }



                });
            } else
                pagar(poliza.id);

            return;

        }

        if (i === 3) {
            let result = poliza.beneficiarios.reduce((acc, cur) => +(acc) + (+cur.porcentaje), 0);
            if (result != 100) {
                setPoliza({ ...poliza, showDialogBeneficiaries: true });
                return !result;
            }
        }

        if (i === 2) {

            let result = poliza.questions
                .filter(x => x.tipo === 0)
                .some(question => question.value === undefined);

            if (result) {
                console.log(result);
                setPoliza({ ...poliza, showDialogRespQuestions: true });
                return !result;
            }

        }

        return true;
    }

    useEffect(() => {

        if (!prevState)
            rest.history.push('/')

        if (prevState && prevState.data) {

            const { nombres, apellidos, email, telefono, sa, frecuenciaPagos, ocupacion, prima, cuota, catactiv, aceptTerminos, edad, pageIndex } = prevState.data;

            setPoliza({
                ...poliza,
                nombres,
                apellidos,
                email,
                telefonoCelular: telefono,
                sa,
                frecuenciaPagos,
                ocupacion,
                catactiv,
                prima,
                primeraCuota: cuota,
                aceptTerminos,
                edad,
                pageIndex
            })
        }

    }, [0]);



    const execute = i => {

        return new Promise((resolve, reject) => {

            if (i === 2) //tarificar
            {

                const imc = getIMCWithInfo(poliza.peso, poliza.estatura, { unidaPeso: poliza.pesoUnidades });

                let data = {
                    "coverageIds": `${COVERAGE_IDS}`,
                    edad: `${getAgeActuarial(poliza.fechaNacimiento)}`,
                    imc,
                    'nCigar': poliza.nCigar ? poliza.nCigar : '0',
                    'suma': poliza.sa,
                    'catactiv': poliza.catactiv,
                    'inmo': poliza.ingresoMoneda,
                    'inme': poliza.ingresoMensual,
                }

                poliza.questions.forEach(question => {
                    const numQuestionYes = `csi${question.numero}`;
                    const numQuestionNot = `cno${question.numero}`;

                    data[numQuestionYes] = question.value ? '1' : '0';
                    data[numQuestionNot] = question.value ? '0' : '1';

                });

                const questionMoto = poliza.questions.find(x => x.numero === 11);

                if (questionMoto && questionMoto.value)
                    data['coverageIds'] = `${COVERAGE_WITH_MOTO_IDS}`;

                const tarificarPlan = tarificar(PLAN_ID);

                tarificarPlan(data).then(resp => {

                    const prima = getResumen(resp.rates);

                    const primaCalutated = calculatePrima(prima);

                    const _prima = parseFloat(primaCalutated(poliza.frecuenciaPagos)).toFixed(2);

                    setPoliza({
                        ...poliza,
                        polCobs: resp.rates,
                        prima: parseFloat(prima).toFixed(2),
                        primeraCuota: parseFloat(_prima).toFixed(2)
                    });

                    resolve(resp);

                }).catch(error => {

                    //enviar correo
                    sendNotificationRate(poliza);
                    setPoliza({ ...poliza, showDialogQuestions: true });

                    reject(error);
                });



            } else
                resolve({})

        })
    }

    const pages = contentTitles.length - 1;

    const validateData = async () => {
        setLoadingValidate(true);
        let dateVingencia = new Date(poliza.fechaVigencia);
        let dateVingenciaStr = convertDateStr(dateVingencia);
        let data  = {
            type: 0,
            customer_name:`${poliza.nombres} ${poliza.apellidos}`,
            document:{
                number: poliza.identificacion,
                document_type: '4',
                expiry_date: dateVingenciaStr,
            },
            media:[
                {
                    type:2,//parte frontal
                    file: `${await createNewFile(poliza.file[0])}`  
                },
                {
                    type:3,//parte trasera
                    file:`${await createNewFile(poliza.file[1])}` 
                }
            ]
        }
       let result = await AllValidate(data);
       setLoadingValidate(false);
        return result;
    }

    const convertDateStr = (d) => {
        let datestring = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
        return datestring
    }

    const createNewFile = async(file) => {
        //BAJAMOS EL PESO
        console.log(file.size);
        let tempFile = await resizeFile(file);
        //PASAMOS LA IMAGEN A BASE64
        console.log(tempFile.size);
        let newFile = await getBase64(tempFile);
        return newFile
    }

    const getBase64 = async(file) => {
        return new Promise((resolve, reject) => {
            const reader  = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.replace('data:image/jpeg;base64,', ''));
        });
    }

    const resizeFile = async (file) => 
    {
        return new Promise((resolve) => {
            new Compressor(file,{
                quality:0.1,
                type:"file",
                convertSize: 250000,
                success(result){
                    resolve(result);
                }
            });
        });
    }

   

    //const btnNotVisible = index === 0 ? 'no-visibility' : '';

    const handleSubmit = async (e) => {

        let result = document.querySelector('form').reportValidity();



        if (result) {

            await execute(index);

            result = await validateQuestions(index);
            if (result)
                increment(true);
        }

    }

    const back = () => {
        rest.history.push('/', { data: poliza });
    }
    const textNext = index === pages ? 'Finalizar' : 'Siguiente';

    const getTextLastPage = tipPago => {

        if (tipPago === true)
            return 'Finalizar';

        if (tipPago === false)
            return 'Pagar';

        return '';

    }

    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };

    return (
        <div className="layout">
            <h2>{contentTitles[index]}</h2>
            <IconProgressBar indexProgress={index} />
            <form action="" className='d-grid'>
                {loading === false && <Pages indexProgress={index} />}
                <ControlButton>

                    <button className={`control-button-btn prev`}
                        type="button"
                        onClick={decrement}>Regresar</button>

                    {index < pages &&
                        <button className="control-button-btn next"
                            type="button"
                            onClick={handleSubmit}>
                            {textNext}
                            {index !== pages && <ImgNext />}
                        </button>
                    }

                    {
                        index === pages && poliza.tipPago !== undefined &&
                        <button className="control-button-btn next"
                            type="button"
                            onClick={handleSubmit}>
                            {getTextLastPage(poliza.tipPago)}
                            {index !== pages && <ImgNext />}
                        </button>
                    }

                </ControlButton>
            </form>
            <Modal
                isOpen={openModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
                style={customStyles}
            >
                <div className="dialog-center-content">
                    <h2 className="txt-primary">¡Ups, existe un problema con los prerrequisitos!</h2>
                </div>
                <div className="dialog-center-content">
                    <ImgAlert />
                </div>
                <br />
                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={() => setOpenModal(false)}>Confirmar</button>
                </div>
            </Modal>

            <Modal
                isOpen={loadingValidate}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
                style={customStyles}
            >
                <div className="dialog-center-content">
                    <h2 className="txt-primary">¡Validando informacion!</h2>
                </div>
                <br />
            </Modal>
        </div>
    )

}

Root.propTypes = {
    /** current locale */
    locale: PropTypes.string,
    user: PropTypes.object,
};


export default Root;
